import {
  ArrowsInLineHorizontal,
  GridNine,
  PaintBrush,
  Plus,
  TrashSimple,
} from '@phosphor-icons/react'
import { Editor } from '@tiptap/react'
import { Popover } from 'antd'
import { useState } from 'react'

import cn from '@/utils/tailwind/cn'

type Props = {
  editor: Editor
}

export const TextEditorToolbarTable = ({ editor }: Props) => {
  const [isOpen, setIsOpen] = useState(false)

  const closePopover = () => setIsOpen(false)

  const tableList = [
    {
      id: 'insert-table',
      label: 'Add Table',
      icon: <Plus />,
      onClick: () =>
        editor
          .chain()
          .focus()
          .insertTable({ rows: 3, cols: 3, withHeaderRow: true })
          .run(),
    },
    {
      id: 'insert-column-left',
      label: 'Add column left',
      icon: <Plus />,
      onClick: () => editor.chain().focus().addColumnBefore().run(),
    },
    {
      id: 'insert-column-right',
      label: 'Add column right',
      icon: <Plus />,
      onClick: () => editor.chain().focus().addColumnAfter().run(),
    },
    {
      id: 'insert-row-above',
      label: 'Add row above',
      icon: <Plus />,
      onClick: () => editor.chain().focus().addRowBefore().run(),
    },
    {
      id: 'insert-row-below',
      label: 'Add row below',
      icon: <Plus />,
      onClick: () => editor.chain().focus().addRowAfter().run(),
    },
    {
      id: 'delete-table',
      label: 'Delete Table',
      icon: <TrashSimple />,
      onClick: () => editor.chain().focus().deleteTable().run(),
    },
    {
      id: 'delete-column',
      label: 'Delete column',
      icon: <TrashSimple />,
      onClick: () => editor.chain().focus().deleteColumn().run(),
    },
    {
      id: 'delete-row',
      label: 'Delete row',
      icon: <TrashSimple />,
      onClick: () => editor.chain().focus().deleteRow().run(),
    },
    {
      id: 'toggle-row',
      label: 'Toggle row',
      icon: <PaintBrush />,
      onClick: () => editor.chain().focus().toggleHeaderRow().run(),
    },
    {
      id: 'toggle-header',
      label: 'Toggle column',
      icon: <PaintBrush />,
      onClick: () => editor.chain().focus().toggleHeaderColumn().run(),
    },
    {
      id: 'toggle-cell',
      label: 'Toggle cell',
      icon: <PaintBrush />,
      onClick: () => editor.chain().focus().toggleHeaderCell().run(),
    },
    {
      id: 'Merge-cells',
      label: 'Merge cells',
      icon: <ArrowsInLineHorizontal />,
      onClick: () => editor.chain().focus().mergeCells().run(),
    },
    {
      id: 'Unmerge-cells',
      label: 'Unmerge cells',
      icon: <ArrowsInLineHorizontal />,
      onClick: () => editor.chain().focus().splitCell().run(),
    },
  ]

  return (
    <Popover
      classNames={{ body: '!px-0' }}
      content={
        <div className="grid h-52 w-full grid-flow-col grid-cols-3 grid-rows-5 items-center [&>button:nth-child(11)]:border-b [&>button:nth-child(11)]:border-solid [&>button:nth-child(11)]:border-b-gray-200 [&>button:nth-child(8)]:border-b [&>button:nth-child(8)]:border-solid [&>button:nth-child(8)]:border-b-gray-200">
          {tableList.map((item) => {
            const isActive = editor.isActive(item.id)
            return (
              <button
                className={cn(
                  'flex w-full items-center justify-start gap-2 rounded-sm border-2 border-transparent bg-transparent py-1.5 pl-2.5 pr-10 text-base outline-none hover:!bg-gray-100 focus:outline-none disabled:cursor-not-allowed',
                  isActive && 'bg-gray-100 text-primary'
                )}
                key={item.id}
                onClick={() => {
                  item.onClick()
                  closePopover()
                }}
                type="button"
              >
                {item.icon} {item.label}
              </button>
            )
          })}
        </div>
      }
      getPopupContainer={() => document.body}
      onOpenChange={() => setIsOpen((old) => !old)}
      open={isOpen}
      placement="bottom"
      trigger="click"
    >
      <button
        className="flex h-6 items-center justify-center gap-1 rounded-sm border-2 border-transparent bg-transparent p-0 text-[22px] text-gray-600 outline-none hover:text-primary focus:outline-none disabled:cursor-not-allowed"
        type="button"
      >
        <GridNine weight="bold" />
      </button>
    </Popover>
  )
}
